import { useGscOnboardingMenuNotification } from '#features/GscOnboarding';
import { useGscSiteVerificationStatus } from '#features/SiteVerification';
import { CHECKOUT_MENU_ITEM } from '../constants/checkoutMenuItem';
import { CONSTRUCTOR_MENU_SECTION } from '../constants/constructorMenuSection';
import {
    ADDONS_MENU_ITEM,
    CLIENTS_MENU_ITEM,
    DASHBOARDS_MENU_ITEM,
    ORDERS_MENU_ITEM,
    PROMOACTIONS_MENU_ITEM,
} from '../constants/mainMenuItem';
import {
    ABC_ANALYSIS_MENU_ITEM,
    BADGES_MENU_ITEM,
    CHARACTERISTICS_MENU_ITEM,
    COLLECTIONS_MENU_ITEM,
    PRODUCTS_MENU_ITEM,
} from '../constants/productsMenuItem';
import { PROMOTION_MENU_ITEM } from '../constants/promotionMenuItem';
import {
    ABOUT_MENU_ITEM,
    API_MENU_ITEM,
    DOMAIN_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    FEEDBACK_MENU_ITEM,
    INVENTORY_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    ORDER_MENU_ITEM,
    OTHER_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    SEO_MENU_ITEM,
    SETTINGS_INTEGRATIONS_MENU_ITEM,
    SETTINGS_ROOT_MENU_ITEM,
} from '../constants/settingsMenuItem';
import { type MenuConfiguration, type MenuSection, type SidebarMenuItem } from '../types';

const KIT_PRODUCTS_MENU_ITEM: SidebarMenuItem = {
    ...PRODUCTS_MENU_ITEM,
    subMenuItems: [CHARACTERISTICS_MENU_ITEM, COLLECTIONS_MENU_ITEM, ABC_ANALYSIS_MENU_ITEM, BADGES_MENU_ITEM],
};

const KIT_MAIN_MENU_SECTION: MenuSection = [
    DASHBOARDS_MENU_ITEM,
    ORDERS_MENU_ITEM,
    KIT_PRODUCTS_MENU_ITEM,
    ADDONS_MENU_ITEM,
    PROMOACTIONS_MENU_ITEM,
    CLIENTS_MENU_ITEM,
    PROMOTION_MENU_ITEM,
];

const useKitGscOnboardingMenuNotification = () => {
    const { isConnected, isConnectionStatusResolved } = useGscSiteVerificationStatus({
        skipSitePublishedStatus: true,
    });

    return useGscOnboardingMenuNotification({ isConnected, isConnectionStatusResolved });
};

const KIT_SETTINGS_INTEGRATIONS_MENU_ITEM: SidebarMenuItem = {
    ...SETTINGS_INTEGRATIONS_MENU_ITEM,
    useHasNotification: useKitGscOnboardingMenuNotification,
};

const KIT_SETTINGS_MENU_SECTION: MenuSection = [
    SETTINGS_ROOT_MENU_ITEM,
    CHECKOUT_MENU_ITEM,
    KIT_SETTINGS_INTEGRATIONS_MENU_ITEM,
];

const KIT_SETTINGS_MENU_ITEMS: SidebarMenuItem[] = [
    ABOUT_MENU_ITEM,
    MANAGERS_MENU_ITEM,
    INVENTORY_MENU_ITEM,
    LOGISTICS_MENU_ITEM,
    PAYMENT_MENU_ITEM,
    DOMAIN_MENU_ITEM,
    EMAIL_NOTIFICATIONS_MENU_ITEM,
    SEO_MENU_ITEM,
    ORDER_MENU_ITEM,
    FEEDBACK_MENU_ITEM,
    API_MENU_ITEM,
    OTHER_MENU_ITEM,
];

export const KIT_MENU_CONFIGURATION: MenuConfiguration = {
    sidebarSections: [KIT_MAIN_MENU_SECTION, KIT_SETTINGS_MENU_SECTION, CONSTRUCTOR_MENU_SECTION],
    settingsMenuItems: KIT_SETTINGS_MENU_ITEMS,
};
